
// this file is automatically generated by git.version.ts script
export const versions = {
  version: '11.4.2',
  revision: '6309d727',
  branch: 'HEAD'
};